
import {
  SofaIcon,
  Building2Icon,
  HammerIcon,
  TreePineIcon,
  RefrigeratorIcon,
  RecycleIcon,
} from 'lucide-react'

export const SERVICES = [
  {
    slug: 'residential',
    icon: SofaIcon,
    title: 'Residential Junk Removal',
    blurb: 'Couches, mattresses, appliances, garage and closet clutter — gone in one trip.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e4fef433-9050-41b9-9aeb-fb2a15d2f2ab.jpg',
    items: ['Furniture & mattresses', 'Appliances', 'Garage & attic cleanouts', 'Yard & shed junk'],
  },
  {
    slug: 'commercial',
    icon: Building2Icon,
    title: 'Commercial & Office',
    blurb: 'Office furniture, retail fixtures, and construction debris cleared on your schedule.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c13ae488-f7ae-4473-a7b9-e6bec989a54c.jpg',
    items: ['Office furniture', 'Retail & restaurant fixtures', 'Construction debris', 'Property turnovers'],
  },
  {
    slug: 'demo',
    icon: HammerIcon,
    title: 'Light Demolition',
    blurb: 'Decks, sheds, fences, and interior tear-outs — we knock it down and haul it off.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8ead82a0-0cf6-44ce-beac-f210382e1eac.jpg',
    items: ['Deck & fence removal', 'Shed teardown', 'Interior demo', 'Hot tub removal'],
  },
]

export const EXTRA_SERVICES = [
  { icon: RefrigeratorIcon, title: 'Appliance Haul-Off', text: 'Fridges, washers, dryers, and water heaters removed and recycled responsibly.' },
  { icon: TreePineIcon, title: 'Yard & Storm Debris', text: 'Fallen limbs, brush piles, and post-storm cleanup cleared out fast.' },
  { icon: RecycleIcon, title: 'Donate & Recycle', text: 'We sort what we haul so usable items get donated, not dumped.' },
]

export const STEPS = [
  { n: '01', title: 'You Call', text: 'Give us a ring or send the quote form. Tell us what you need gone.' },
  { n: '02', title: 'We Quote', text: 'Get a fast, upfront, no-surprises estimate — free every time.' },
  { n: '03', title: 'We Show Up', text: 'The red truck and trailer roll up on time, ready to work.' },
  { n: '04', title: 'We Haul', text: 'We load it, sweep up, and haul it off. You don\'t lift a finger.' },
]

export const WHY = [
  { title: 'Upfront Pricing', text: 'You get the price before we lift anything. No hidden fees, ever.' },
  { title: 'Same-Day Service', text: 'Call in the morning, junk\'s gone by afternoon — most days.' },
  { title: 'Fully Insured', text: 'Licensed and insured, so your property is always protected.' },
  { title: 'We Do The Lifting', text: 'From the basement to the third floor, you never touch the heavy stuff.' },
]

